const initialState = {
  leftPanelExpanded: false,
};

const leftMenuPanelReducer = (state = initialState, action) => {
  switch (action.type) {
    case "leftPanelExpanded":
      return {
        ...state,
        leftPanelExpanded: true,
      };
    case "leftPanelcollapsed":
      return {
        ...state,
        leftPanelExpanded: false,
      };
    default:
      return state;
  }
};

export default leftMenuPanelReducer;
